(function () {
  function getAllowedQuantities(element) {
    return (element.dataset.allowedQuantities || '')
      .split(',')
      .map((value) => parseInt(value, 10))
      .filter((value) => !isNaN(value))
      .sort((a, b) => a - b);
  }

  function updateButtons(quantityInput) {
    const allowed = getAllowedQuantities(quantityInput);
    if (allowed.length === 0) return;

    const input = quantityInput.querySelector('input');
    if (!input) return;

    const value = parseInt(input.value, 10);
    const buttonMinus = quantityInput.querySelector(".quantity__button[name='minus']");
    const buttonPlus = quantityInput.querySelector(".quantity__button[name='plus']");
    if (buttonMinus) buttonMinus.classList.toggle('disabled', value <= allowed[0]);
    if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= allowed[allowed.length - 1]);
  }

  // ONE delegated listener bound to `document` for the lifetime of the page,
  // rather than one listener per <quantity-input>.
  //
  // Why: CartItems.onCartUpdate (assets/cart.js) refreshes the cart by assigning
  // `elementToReplace.innerHTML`, which destroys and recreates every
  // <quantity-input> in the cart. Per-element listeners die with them, and the
  // rebind only happened once `cart:updated` fired at the very END of the chain:
  //
  //   click -> snap -> 'change' -> 300ms debounce -> fetch /cart/change
  //         -> response -> innerHTML replace -> cart:updated -> rebind
  //
  // For that ~300ms + network window the +/- buttons fell back to global.js's
  // own handlers, which step by 1 — so a fast clicker could land on any
  // quantity. Delegating to `document` removes the rebinding window entirely,
  // making click speed irrelevant. Capture phase still runs ahead of global.js.
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      const button = target.closest(".quantity__button[name='minus'], .quantity__button[name='plus']");
      if (!button) return;

      const quantityInput = button.closest('quantity-input[data-allowed-quantities]');
      if (!quantityInput) return;

      const allowed = getAllowedQuantities(quantityInput);
      if (allowed.length === 0) return;

      const input = quantityInput.querySelector('input');
      if (!input) return;

      event.stopImmediatePropagation();
      event.preventDefault();

      const current = parseInt(input.value, 10);
      const next =
        button.name === 'plus'
          ? allowed.find((value) => value > current)
          : allowed
              .slice()
              .reverse()
              .find((value) => value < current);

      if (next !== undefined && next !== current) {
        input.value = next;
        // 'input' drives CartItems' non-debounced validateCartQuantities (instant
        // error text + checkout-button state); 'change' drives the debounced
        // cart update itself. Both are needed.
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateButtons(quantityInput);
    },
    true
  );

  // Keep the +/- disabled states correct on whatever markup is currently mounted.
  // Also delegated, for the same reason as above.
  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const quantityInput = target.closest('quantity-input[data-allowed-quantities]');
    if (quantityInput) updateButtons(quantityInput);
  });

  function refreshAll() {
    document.querySelectorAll('quantity-input[data-allowed-quantities]').forEach(updateButtons);
  }

  // These now only refresh button styling — no listener rebinding depends on them,
  // so a missed event can no longer leave the stepping unenforced.
  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('cart:updated', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('cartdrawer:opened', refreshAll);
  refreshAll();
})();
